"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.BYTES = void 0;
require("../core/baseTypes/Bytes");
exports.BYTES = {
    k: 1024,
    sizes: ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
};
//# sourceMappingURL=bytes.js.map